import { render, staticRenderFns } from "./TowerShow.vue?vue&type=template&id=3141f443&scoped=true"
import script from "./TowerShow.vue?vue&type=script&lang=js"
export * from "./TowerShow.vue?vue&type=script&lang=js"
import style0 from "./TowerShow.vue?vue&type=style&index=0&id=3141f443&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3141f443",
  null
  
)

export default component.exports